export enum StripeCurrency {
	usd = '$',
}

export enum StripeInvoiceStatus {
	draft = 'draft',
	open = 'open',
	paid = 'paid',
	uncollectible = 'uncollectible',
	void = 'void',
	refund = 'refund',
	partiallyRefunded = 'partiallyRefunded',
}
export enum CancelSubscriptionText {
	Cancel = 'cancel',
	Confirm = 'confirm',
	Error = 'error',
}

export enum SubscriptionMode {
	INDIVIDUAL = 'individual',
	UNIFIED = 'unified',
}
